import React, { useEffect, useRef, useState } from "react";
import "./layout.scss";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import categoryStore from "../../store/categoryStore";
import productStore from "../../store/productStore";
import searchTagStore from "../../store/searchTagStore";
import authStore from "../../store/authStore";
import BottomPart from "../../components/bottomPart/BottomPart";
import cartStore from "../../store/cartStore";
import addressStore from "../../store/addressStore";
import wishlistStore from "../../store/wishlistStore";
import couponStore from "../../store/couponStore";
import orderStore from "../../store/orderStore";
import paymentStore from "../../store/paymentStore";
import orderDeliveryStatusTimeStore from "../../store/orderDeliveryStatusTimeStore";
import productRatingStore from "../../store/productRatingStore";
import orderReturnRequestStore from "../../store/orderReturnRequestStore";
import userStore from "../../store/userStore";
import { trackVisit } from "../../utils/trackVisit";

const Layout = () => {
  const matches = useMediaQuery("(max-width:900px)");
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const AuthStore = authStore();
  const CategoryStore = categoryStore();
  const ProductStore = productStore();
  const SearchTagStore = searchTagStore();
  const CartStore = cartStore();
  const AddressStore = addressStore();
  const WishlistStore = wishlistStore();
  const CouponStore = couponStore();
  const OrderStore = orderStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const PaymentStore = paymentStore();
  const ProductRatingStore = productRatingStore();
  const OrderReturnRequestStore = orderReturnRequestStore();
  const UserStore = userStore();

  const location = useLocation();
  const [lastPathName, setLastPathname] = useState();
  const hasLogged = useRef(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    AuthStore.clearWhereNavigate();
    AuthStore.checkAuth();
    await CategoryStore.fetchAllCategory();
    CategoryStore.setGenderWishCategory();
    ProductStore.fetchNewProduct();
    ProductStore.fetchAllProduct();
    UserStore.fetchAllProductRating();
    SearchTagStore.fetchAllSearchTag();
    ProductRatingStore.fetchAllProductRating();
  };

  useEffect(() => {
    fetchAllIsLogged();
  }, [AuthStore.isLogged]);

  useEffect(() => {
    if (hasLogged.current) return;
    hasLogged.current = true;

    if (lastPathName !== location.pathname) {
      setLastPathname(location.pathname);
      if (process.env.REACT_APP_PRODUCTION === "production") {
        trackVisit(null, location.pathname);
      }
    }
  }, [location.pathname]);

  const fetchAllIsLogged = async () => {
    if (AuthStore.isLogged === true) {
      await CartStore.fetchAllCartProduct();
      await AddressStore.fetchAllUserAddress();
      await WishlistStore.fetchAllWishlistProduct();
      await PaymentStore.fetchAllUserPayments();
      await CouponStore.fetchAllCoupon();
      await OrderReturnRequestStore.fetchUserOrderReturnRequest();
      await OrderDeliveryStatusTimeStore.fetchOrderDeliveryStatusTime();
      await OrderStore.fetchAllUserOrders();
      await ProductRatingStore.fetchAllUserProductRating();
    } else if (AuthStore.isLogged === false) {
      CartStore.setIsLoading({ value: false });
    }
  };

  useEffect(() => {
    outOfStockProductRemoveCart();
  }, [ProductStore.isLoading, CartStore.isLoading]);

  const outOfStockProductRemoveCart = async () => {
    if (!ProductStore.isLoading && !CartStore.isLoading) {
      await CartStore.outOfStockProductRemoveCart();
    }
  };

  useEffect(() => {
    setIsOpenSidebar(false);
  }, [matches]);

  return (
    <div className="container">
      <Sidebar
        isOpenSidebar={isOpenSidebar}
        setIsOpenSidebar={setIsOpenSidebar}
      />
      <div className="mainContent">
        <Navbar
          isOpenSidebar={isOpenSidebar}
          setIsOpenSidebar={setIsOpenSidebar}
        />

        <div className="bodyContent">
          <div
            className={`set-container ${location.pathname === "/" ? "home" : ""}`}
          >
            <Outlet />
            <BottomPart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
